import type { Candidate } from '@entities/candidates';
import type { CandidatePrivateDataProps } from '@features/candidate/candidate-private-data';

export const mapCandidateToPrivateDataProps = (
  candidate: Candidate
): CandidatePrivateDataProps => ({
  data: {
    firstName: candidate.firstName,
    lastName: candidate.lastName,
    allCities: candidate.allCities,
    birthAt: candidate.birthAt,
    cityIds: candidate.cityIds,
    educationLevel: candidate.educationLevel,
    generalInfo: candidate.generalInfo,
    interviewRequired: candidate.interviewRequired,
    phone: candidate.phone,
    preferredCommunicationLanguage: candidate.preferredCommunicationLanguage,
  },
});
